export const makeFileName = (ns: string, ln: string): string => `./${ns}_${ln}.json`;

export default async (file: string): Promise<Record<string, string>> => {
  const files = require.context('./locales', false, /\.json$/, 'lazy');
  return files(file);
};
